import { createAddressButtonStyles } from "@insite/content-library/Widgets/Addresses/CreateAddressButton";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import { css } from "styled-components";

createAddressButtonStyles.createNewAddressButton = {
    css: css`
        border-radius: 25px;
        border: 1px solid ${COLORS.background.yellow};
        background-color: ${COLORS.background.yellow};
        > span {
            color: ${COLORS.black} !important;
            font-family: ${TYPOGRAPHY.fontFamily.base};
        }
        &:hover {
            border: 1px solid ${COLORS.background.mango};
            background-color: ${COLORS.background.mango};
        }
    `,
}